import React, { useEffect, useRef, useState } from "react";
import { Grid } from "components/Grid";
import ActionsBar from "components/SubHeader/ActionsBar";
import SubHeader from "components/SubHeader";
import SubHeaderTitle from "components/SubHeader/SubHeaderTitle";
import { AddProvinceModal } from "views/dashboard/provinces/AddProvinceModal";
import { useTranslation } from "react-i18next";
import { netCall } from "utils/netCall";
import { ManagementApiUrl } from "environment/routeSettings";
import { TCity, TProvince } from "types/dto";
import { toast } from "react-toastify";
import {
  EditProvinceModal,
  TEditFormTypes,
} from "views/dashboard/provinces/EditProvinceModal";
import { TAddFormTypes } from "views/dashboard/provinces/AddProvinceModal";
import { TResponseCode } from "utils/netCall/types";

// NOTE: this file is a near-duplicate of views/dashboard/provinces (same
// RegionsView name, same province CRUD) whose local modal folders were never
// created — hence the broken imports. The imports now point at the province
// modals that do exist, which unblocks the build, but the page itself is still
// a provinces screen sitting on the /dashboard/installations/history route and
// almost certainly needs replacing or removing.
const RegionsView = () => {
  const { t } = useTranslation();
  const [provinces, setProvinces] = useState<TProvince[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState<TProvince>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const provinceGridRef = useRef(null);

  const onAddClick = () => {
    setAddModalOpen(true);
  };

  const onEditClick = (data: any) => {
    setSelectedProvince(data.row.data);
    setEditModalOpen(true);
  };

  const onSubmitAddProvince = async (values: TAddFormTypes) => {
    setIsSubmitting(true);
    const res = await netCall<TProvince>({
      method: "POST",
      endPoint: `${ManagementApiUrl()}/api/Province/AddProvince`,
      body: {
        name: values.name,
      },
    });
    if (res.responseCode === TResponseCode.OK) {
      setIsSubmitting(false);
      toast.success(t("operationSuccessful"));
      getProvinceList();
      setAddModalOpen(false);
      setSelectedProvince(undefined);
    } else {
      setIsSubmitting(false);
      toast.error(t("operationFailed"));
    }
  };

  const onSubmitEditProvince = async (values: TEditFormTypes) => {
    if (selectedProvince) {
      setIsSubmitting(true);
      const res = await netCall<TCity>({
        method: "POST",
        endPoint: `${ManagementApiUrl()}/api/Province/UpdateProvince`,
        body: {
          id: selectedProvince.id,
          name: values.name,
        },
      });
      if (res.responseCode === TResponseCode.OK) {
        setIsSubmitting(false);
        toast.success(t("operationSuccessful"));
        getProvinceList();
        setEditModalOpen(false);
        setSelectedProvince(undefined);
      } else {
        setIsSubmitting(false);
        toast.error(t("operationFailed"));
      }
    }
  };

  const getProvinceList = async () => {
    setIsLoading(true);
    const res = await netCall<TProvince[]>({
      method: "POST",
      endPoint: `${ManagementApiUrl()}/api/Province/GetAllProvince`,
    });
    if (res.responseCode === TResponseCode.OK) {
      setProvinces(res.results || []);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      toast.warning(t("fetchDataError"));
    }
  };
  useEffect(() => {
    getProvinceList();
  }, []);
  return (
    <>
      <SubHeader>
        <SubHeaderTitle>{t("installationsHistory")}</SubHeaderTitle>
        {/*<ActionsBar*/}
        {/*  requestTime={0}*/}
        {/*  isLoading={false}*/}
        {/*  actionButtons={[*/}
        {/*    {*/}
        {/*      iconName: "MdAdd",*/}
        {/*      buttonTooltip: "افزودن",*/}
        {/*      action: onAddClick,*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*/>*/}
      </SubHeader>

      <div className={"w-full flex gap-x h-full"}>
        <Grid
          ref={provinceGridRef}
          gridKey={"id"}
          isLoading={isLoading}
          dataSource={provinces}
          columns={[
            {
              dataField: "id",
              caption: t("id"),
            },
            {
              dataField: "name",
              caption: t("name"),
            },
            {
              caption: t("actions"),
              visible: true,
              width: 110,
              buttons: [
                {
                  icon: "fa-solid fa-pencil",
                  hint: t("edit"),
                  onClick: onEditClick,
                },
              ],
            },
          ]}
          hasSearchPanel={false}
          hasPagination={true}
          hasGroupingFeatures={false}
          hasFilterBuilder={false}
        />
      </div>

      {/*{addModalOpen && (*/}
      {/*  <AddProvinceModal*/}
      {/*    onClose={() => setAddModalOpen(false)}*/}
      {/*    isOpen={addModalOpen}*/}
      {/*    onSubmit={onSubmitAddProvince}*/}
      {/*    isLoading={isSubmitting}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{editModalOpen && (*/}
      {/*  <EditProvinceModal*/}
      {/*    record={selectedProvince}*/}
      {/*    onClose={() => {*/}
      {/*      setEditModalOpen(false);*/}
      {/*      setSelectedProvince(undefined);*/}
      {/*    }}*/}
      {/*    isOpen={editModalOpen}*/}
      {/*    onSubmit={onSubmitEditProvince}*/}
      {/*    isLoading={isSubmitting}*/}
      {/*  />*/}
      {/*)}*/}
    </>
  );
};

export default RegionsView;
